export function returnDateOnIntersections(date1, date2, outPutValue) {
  if (date1 === date2) return outPutValue;
  return null;
}
